// Open overlays in mount order; the last one is the topmost on screen.
const stack: symbol[] = []

const listeners = new Set<() => void>()

function notify() {
	for (const listener of listeners) {
		listener()
	}
}

export function pushOverlay(token: symbol): () => void {
	stack.push(token)
	notify()

	return () => {
		const index = stack.indexOf(token)
		if (index === -1) return
		stack.splice(index, 1)
		notify()
	}
}

export function subscribeOverlayStack(listener: () => void): () => void {
	listeners.add(listener)
	return () => {
		listeners.delete(listener)
	}
}

export function isTopmostOverlay(token: symbol): boolean {
	const top = stack[stack.length - 1]
	return top === undefined || top === token
}
